import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect } from "vue"

const _hoisted_1 = { class: "card-body p-xl-40" }
const _hoisted_2 = { class: "fs-18 mb-35 text-title fw-semibold" }
const _hoisted_3 = {
  key: 0,
  class: "text-center py-4"
}
const _hoisted_4 = {
  key: 1,
  class: "table-responsive style-one"
}
const _hoisted_5 = { class: "table text-nowrap align-middle mb-0" }
const _hoisted_6 = {
  scope: "col",
  class: "text-title fw-normal fs-14 pt-0 ps-0"
}
const _hoisted_7 = {
  scope: "col",
  class: "text-title fw-normal fs-14 pt-0"
}
const _hoisted_8 = {
  scope: "col",
  class: "text-title fw-normal fs-14 pt-0"
}
const _hoisted_9 = {
  scope: "col",
  class: "text-title fw-normal fs-14 pt-0"
}
const _hoisted_10 = {
  scope: "col",
  class: "text-title fw-normal fs-14 pt-0"
}
const _hoisted_11 = {
  scope: "col",
  class: "text-title fw-normal fs-14 pt-0"
}
const _hoisted_12 = {
  scope: "col",
  class: "text-title fw-normal fs-14 pt-0 pe-0"
}
const _hoisted_13 = {
  scope: "col",
  class: "text-title fw-normal fs-14 pt-0 pe-0"
}
const _hoisted_14 = { class: "shadow-none fw-normal text-black title ps-0" }
const _hoisted_15 = { class: "shadow-none lh-1 fs-14 fw-normal text-paragraph" }
const _hoisted_16 = { class: "shadow-none lh-1 fs-14 fw-normal text-paragraph" }
const _hoisted_17 = { class: "shadow-none lh-1 fs-14 fw-normal text-paragraph" }
const _hoisted_18 = { class: "shadow-none lh-1 fs-14 fw-normal text-paragraph" }
const _hoisted_19 = { class: "shadow-none lh-1 fs-14 fw-normal text-paragraph" }
const _hoisted_20 = { class: "shadow-none lh-1 fs-14 fw-normal text-paragraph" }
const _hoisted_21 = { class: "shadow-none lh-1 fs-14 fw-normal text-paragraph pe-0" }
const _hoisted_22 = ["onClick"]
const _hoisted_23 = { key: 0 }
const _hoisted_24 = {
  colspan: "8",
  class: "text-center py-4 text-muted"
}
const _hoisted_25 = {
  class: "modal fade",
  id: "paymentModal",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_26 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_27 = { class: "modal-content border-0 shadow" }
const _hoisted_28 = { class: "modal-header bg-primary text-white border-0" }
const _hoisted_29 = { class: "modal-title fw-bold text-white" }
const _hoisted_30 = {
  key: 0,
  class: "modal-body p-4"
}
const _hoisted_31 = { class: "mb-3" }
const _hoisted_32 = { class: "form-label fs-14 fw-medium text-paragraph" }
const _hoisted_33 = ["value"]
const _hoisted_34 = { class: "mb-3" }
const _hoisted_35 = { class: "form-label fs-14 fw-medium text-paragraph" }
const _hoisted_36 = ["value"]
const _hoisted_37 = { class: "mb-3" }
const _hoisted_38 = { class: "form-label fs-14 fw-medium text-paragraph" }
const _hoisted_39 = ["max"]
const _hoisted_40 = { class: "mb-3" }
const _hoisted_41 = { class: "form-label fs-14 fw-medium text-paragraph" }
const _hoisted_42 = { value: null }
const _hoisted_43 = ["value"]
const _hoisted_44 = { class: "modal-footer border-0 p-4 pt-0" }
const _hoisted_45 = {
  type: "button",
  class: "btn btn-secondary h-55 px-4",
  "data-bs-dismiss": "modal"
}
const _hoisted_46 = ["disabled"]
const _hoisted_47 = {
  key: 0,
  class: "spinner-border spinner-border-sm me-2"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h6", _hoisted_2, _toDisplayString(_ctx.$t("dashboard_page.recent_sales_due")), 1),
    (_ctx.isLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("span", null, _toDisplayString(_ctx.$t("loading")), 1)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("table", _hoisted_5, [
            _createElementVNode("thead", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("th", _hoisted_6, _toDisplayString(_ctx.$t("dashboard_page.reference")), 1),
                _createElementVNode("th", _hoisted_7, _toDisplayString(_ctx.$t("dashboard_page.customer")), 1),
                _createElementVNode("th", _hoisted_8, _toDisplayString(_ctx.$t("dashboard_page.status")), 1),
                _createElementVNode("th", _hoisted_9, _toDisplayString(_ctx.$t("dashboard_page.grand_total")), 1),
                _createElementVNode("th", _hoisted_10, _toDisplayString(_ctx.$t("dashboard_page.paid")), 1),
                _createElementVNode("th", _hoisted_11, _toDisplayString(_ctx.$t("dashboard_page.due")), 1),
                _createElementVNode("th", _hoisted_12, _toDisplayString(_ctx.$t("dashboard_page.payment_status")), 1),
                _createElementVNode("th", _hoisted_13, _toDisplayString(_ctx.$t("common.action")), 1)
              ])
            ]),
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.recentSales, (sale) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: sale.id
                }, [
                  _createElementVNode("td", _hoisted_14, [
                    _createVNode(_component_router_link, {
                      to: '/sales-report',
                      class: "text-light-purple text-decoration-underline fs-14 fw-semibold"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(sale.reference_no), 1)
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _createElementVNode("td", _hoisted_15, _toDisplayString(sale.customer_name), 1),
                  _createElementVNode("td", _hoisted_16, [
                    _createElementVNode("span", {
                      class: _normalizeClass(["badge fs-14 fw-normal", String(sale.status || '').toLowerCase() === 'completed' ? 'badge-success' : 'badge-danger'])
                    }, _toDisplayString(_ctx.formatSaleStatus(sale.status)), 3)
                  ]),
                  _createElementVNode("td", _hoisted_17, " $" + _toDisplayString(Number(sale.grand_total).toFixed(2)), 1),
                  _createElementVNode("td", _hoisted_18, " $" + _toDisplayString(Number(sale.paid).toFixed(2)), 1),
                  _createElementVNode("td", _hoisted_19, " $" + _toDisplayString(Number(sale.due).toFixed(2)), 1),
                  _createElementVNode("td", _hoisted_20, [
                    _createElementVNode("span", {
                      class: _normalizeClass(["badge style-two fs-14 fw-medium", _ctx.getPaymentStatusClass(sale.payment_status)])
                    }, _toDisplayString(_ctx.formatPaymentStatus(sale.payment_status)), 3)
                  ]),
                  _createElementVNode("td", _hoisted_21, [
                    _createElementVNode("button", {
                      class: "btn btn-sm btn-primary py-1 px-2 fs-12",
                      "data-bs-toggle": "modal",
                      "data-bs-target": "#paymentModal",
                      onClick: ($event: any) => (_ctx.openPaymentModal(sale))
                    }, _toDisplayString(_ctx.$t("dashboard_page.payment")), 9, _hoisted_22)
                  ])
                ]))
              }), 128)),
              (_ctx.recentSales.length === 0)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_23, [
                    _createElementVNode("td", _hoisted_24, _toDisplayString(_ctx.$t("dashboard_page.no_recent_sales")), 1)
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ])),
    _createElementVNode("div", _hoisted_25, [
      _createElementVNode("div", _hoisted_26, [
        _createElementVNode("div", _hoisted_27, [
          _createElementVNode("div", _hoisted_28, [
            _createElementVNode("h5", _hoisted_29, _toDisplayString(_ctx.$t("dashboard_page.add_payment")), 1),
            _cache[3] || (_cache[3] = _createElementVNode("button", {
              type: "button",
              class: "btn-close btn-close-white",
              "data-bs-dismiss": "modal",
              "aria-label": "Close"
            }, null, -1))
          ]),
          (_ctx.selectedSale)
            ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                _createElementVNode("div", _hoisted_31, [
                  _createElementVNode("label", _hoisted_32, _toDisplayString(_ctx.$t("dashboard_page.reference")), 1),
                  _createElementVNode("input", {
                    type: "text",
                    class: "form-control bg-light border-0",
                    value: _ctx.selectedSale.reference_no,
                    readonly: ""
                  }, null, 8, _hoisted_33)
                ]),
                _createElementVNode("div", _hoisted_34, [
                  _createElementVNode("label", _hoisted_35, _toDisplayString(_ctx.$t("dashboard_page.total_due")), 1),
                  _createElementVNode("input", {
                    type: "text",
                    class: "form-control bg-light border-0",
                    value: '$' + Number(_ctx.selectedSale.due).toFixed(2),
                    readonly: ""
                  }, null, 8, _hoisted_36)
                ]),
                _createElementVNode("div", _hoisted_37, [
                  _createElementVNode("label", _hoisted_38, _toDisplayString(_ctx.$t("dashboard_page.payment_amount")), 1),
                  _withDirectives(_createElementVNode("input", {
                    type: "number",
                    class: "form-control h-55",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.paymentAmount) = $event)),
                    max: _ctx.selectedSale.due,
                    step: "0.01"
                  }, null, 8, _hoisted_39), [
                    [_vModelText, _ctx.paymentAmount]
                  ])
                ]),
                _createElementVNode("div", _hoisted_40, [
                  _createElementVNode("label", _hoisted_41, _toDisplayString(_ctx.$t("dashboard_page.payment_method")), 1),
                  _withDirectives(_createElementVNode("select", {
                    class: "form-select h-55",
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.paymentMethodId) = $event))
                  }, [
                    _createElementVNode("option", _hoisted_42, _toDisplayString(_ctx.$t("dashboard_page.choose_payment_method")), 1),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.paymentMethods, (method) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: method.id,
                        value: method.id
                      }, _toDisplayString(method.name), 9, _hoisted_43))
                    }), 128))
                  ], 512), [
                    [
                      _vModelSelect,
                      _ctx.paymentMethodId,
                      void 0,
                      { number: true }
                    ]
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_44, [
            _createElementVNode("button", _hoisted_45, _toDisplayString(_ctx.$t("common.cancel")), 1),
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-primary h-55 px-4",
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.submitPayment && _ctx.submitPayment(...args))),
              disabled: _ctx.isSubmittingPayment || _ctx.paymentAmount <= 0 || _ctx.paymentAmount > (_ctx.selectedSale?.due || 0) || !_ctx.paymentMethodId
            }, [
              (_ctx.isSubmittingPayment)
                ? (_openBlock(), _createElementBlock("span", _hoisted_47))
                : _createCommentVNode("", true),
              _createTextVNode(" " + _toDisplayString(_ctx.$t("dashboard_page.submit_payment")), 1)
            ], 8, _hoisted_46)
          ])
        ])
      ])
    ])
  ]))
}